
import * as React from "react";

import { generateMarkup } from "../../helpers/generateMarkup";

type IProps = {
  content: string;
};

const Html = (props: IProps) => <div>
        {generateMarkup(props.content)}
    </div>;

export default Html;